<template>
  <div class="home">
    <a href="javascript:;" @click.stop="onWebOprateOpen">
      <a-alert message="學會報名操作流程" type="info" show-icon class="web-oprate" closable @close.stop="onClose"/>
    </a>
    <div class="container" v-if="data">
      <div class="carousel-container">
        <a-carousel arrows :autoplay="true">
          <div
            slot="prevArrow"
            :slot-scope="slotScope"
            class="custom-slick-arrow"
            style="left: 10px;z-index: 1"
          >
            <a-icon type="left-circle" />
          </div>
          <div slot="nextArrow" :slot-scope="slotScope" class="custom-slick-arrow" style="right: 10px">
            <a-icon type="right-circle" />
          </div>
          <img class="carousel-item" v-for="(img, index) in dotImgs" :key="index" :src="img.p"/>
        </a-carousel>
        <div class="hint" v-if="dotText" v-text="dotText"></div>
      </div>
      <div v-if="!videoUrl && !videoUrl2">
        <div class="row">
          <div class="content-box news-list">
            <div class="head">
              <div class="title"><a-icon type="snippets" />最近資訊</div>
              <router-link class="more" to="/AssociationNews/list">更多<a-icon type="double-right" /></router-link>
            </div>
            <div class="datas">
              <router-link class="data-item" :to="`/News/details/${news.newsid}`" v-for="(news, index) in newsList" :key="index">
                <p v-text="news.title"></p>
              </router-link>
            </div>
          </div>
          <div class="content-box academic-list">
            <div class="head">
              <div class="title"><a-icon type="file-pdf" />學術及文化</div>
              <router-link class="more" to="/LiteratureList">更多<a-icon type="double-right" /></router-link>
            </div>
            <div class="list">
              <router-link class="item" v-for="(article, index) in articles" :key="index" :to="`/LiteratureDetail/${article.articleid}`">
                <!-- <img src="https://www.ectcm.com/upfiles/img/1903/20190323065517.jpg" alt="" class="preview"> -->
                <p class="title" v-text="article.title"></p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="content-box activity-list">
            <div class="head">
              <div class="title"><a-icon type="schedule" />最近課程及活動</div>
              <router-link class="more" to="/ActivityList">更多<a-icon type="double-right" /></router-link>
            </div>
            <div class="list">
              <router-link :to="`/ActivityDetail/${activity.activityid}`" class="item" v-for="(activity, index) in activitys" :key="index">
                <img :src="activity.coverpicurl" alt="">
                <p class="title" v-text="`${activity.starttime.substring(0, 10)} 至 ${activity.endtime.substring(0, 10)} \r\n ${activity.title}`"></p>
              </router-link>
            </div>
          </div>
          <div class="content-box news-list2">
            <div class="datas">
              <router-link class="data-item" :to="`/News/details/${news.newsid}`" v-for="(news, index) in newsList2" :key="index">
                <h3 v-text="news.title"></h3>
                <p v-text="news.introduce"></p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-if="videoUrl && videoUrl2">
        <div class="row">
          <div class="content-box">
            <div class="head">
              <div class="title"><a-icon type="play-circle" /><span v-text="videoTitle"></span></div>
            </div>
            <div class="videos">
              <video id="osvideo" class="video" controls="" autoplay="autoplay">
                <source :src="videoUrl" type="video/mp4">
              </video>
            </div>
          </div>
          <div class="content-box">
            <div class="head">
              <div class="title"><a-icon type="play-circle" /><span v-text="videoTitle2"></span></div>
            </div>
            <div class="videos">
              <video id="osvideo" class="video" controls="" autoplay="autoplay">
                <source :src="videoUrl2" type="video/mp4">
              </video>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="content-box news-list">
            <div class="head">
              <div class="title"><a-icon type="snippets" />最近資訊</div>
              <router-link class="more" to="/AssociationNews/list">更多<a-icon type="double-right" /></router-link>
            </div>
            <div class="datas">
              <router-link class="data-item" :to="`/News/details/${news.newsid}`" v-for="(news, index) in newsList" :key="index">
                <p v-text="news.title"></p>
              </router-link>
            </div>
          </div>
          <div class="content-box academic-list">
            <div class="head">
              <div class="title"><a-icon type="file-pdf" />學術及文化</div>
              <router-link class="more" to="/LiteratureList">更多<a-icon type="double-right" /></router-link>
            </div>
            <div class="list">
              <router-link class="item" v-for="(article, index) in articles" :key="index" :to="`/LiteratureDetail/${article.articleid}`">
                <!-- <img src="https://www.ectcm.com/upfiles/img/1903/20190323065517.jpg" alt="" class="preview"> -->
                <p class="title" v-text="article.title"></p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
        </div>
      </div>
      <div v-if="(videoUrl && !videoUrl2) || (!videoUrl && videoUrl2)">
        <div class="row">
          <div class="content-box">
            <div class="head">
              <div class="title"><a-icon type="play-circle" /><span v-text="videoTitle || videoTitle2"></span></div>
            </div>
            <div class="videos">
              <video id="osvideo" class="video" controls="" autoplay="autoplay">
                <source :src="videoUrl || videoUrl2" type="video/mp4">
              </video>
            </div>
          </div>
          <div class="content-box news-list">
            <div class="head">
              <div class="title"><a-icon type="snippets" />最近資訊</div>
              <router-link class="more" to="/AssociationNews/list">更多<a-icon type="double-right" /></router-link>
            </div>
            <div class="datas">
              <router-link class="data-item" :to="`/AssociationNews/details/${news.newsid}`" v-for="(news, index) in newsList" :key="index">
                <p v-text="news.title"></p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="row">
        </div>
        <div class="row">
          <div class="content-box news-list2">
            <div class="datas">
              <router-link class="data-item" :to="`/AssociationNews/details/${news.newsid}`" v-for="(news, index) in newsList2" :key="index">
                <h3 v-text="news.title"></h3>
                <p v-text="news.introduce"></p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <loading v-if="loading" />
    </div>
    <a-modal
      title="學會報名操作流程"
      :visible="showWebOperate"
      style="z-index: 10001; top: 20px !important;"
      width="95%"
      :maskClosable="false"
      @cancel="onWebOprateClose"
      :footer="null">
      <!-- <div :style="{width: '100%', height: height, 'overflow-y': 'scroll'}"> -->
        <iframe :src="'https://www.ectcm.com/upfiles/學會報名操作流程.pdf?_t='+Date.now()" :style="{width: '100%','min-height': '500px', 'border': '0px'}"/>
      <!-- <canvas
        v-for="page in pdfPages"
        :key="page"
        :id="'pdfCanvas' + page"
      ></canvas> -->

<!-- </div> -->
        <!-- <embed :height="height" src="./學會報名操作流程.pdf" style="width: 100%;"/> -->
  </a-modal>
  </div>
</template>

<script>
  const PDFJS = require("pdfjs-dist");
  PDFJS.GlobalWorkerOptions.workerSrc =
"https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.5.207/pdf.worker.js";
  import Loading from '../components/Loading.vue'
  export default {
    components: {
      // pdf,
      Loading
    },
    props: {
      onLogoLoad: Function,
    },
    data(){
        return {
          showWebOprate: true,
          loading: false,
          slotScope: 'props',
          data: null,
          dotText: '',
          style: '',
          height: '500px',

          pdfPages: [], // 页数
          pdfWidth: "", // 宽度
          pdfSrc: "", // 地址
          pdfDoc: "", // 文档内容
          pdfScale: 1, // 放大倍数

          showWebOperate: false,
          dotImgs: [],
          activitys: [],
          articles: [],
          newsList: [],
          newsList2: [],

          videoUrl: '',
          videoUrl2: '',
          videoTitle: '',
          videoTitle2: '',
        }
    },
    created: function(){
      this.pdfScale = document.body.clientWidth/1400;
      this.height = `${document.body.clientHeight - 200}px`;
    },
    mounted: function(){
      this.onRefresh()
    },
    methods: {
      onClose(e){
        console.log(e, 'I was closed.');
      },
      loadFile(url) {
        let loadingTask = PDFJS.getDocument(url);
        loadingTask.promise.then(pdf => {
          this.pdfDoc = pdf;
          this.pdfPages = pdf.numPages;
          this.$nextTick(() => { 
            this.renderPage(1);
          });
        });
      },
      renderPage(num) {
        const that = this;
        this.pdfDoc.getPage(num).then(page => {
          let canvas = document.getElementById("pdfCanvas" + num);
          let ctx = canvas.getContext("2d");
          let dpr = window.devicePixelRatio || 1;
          let bsr =
            ctx.webkitBackingStorePixelRatio ||
            ctx.mozBackingStorePixelRatio ||
            ctx.msBackingStorePixelRatio ||
            ctx.oBackingStorePixelRatio ||
            ctx.backingStorePixelRatio ||
            1;
          let ratio = dpr / bsr;
          let viewport = page.getViewport({ scale: this.pdfScale });
          canvas.width = viewport.width * ratio;
          canvas.height = viewport.height * ratio;

          canvas.style.width = viewport.width + "px";

          that.pdfWidth = viewport.width + "px";

          canvas.style.height = viewport.height + "px";

          ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
          // 将 PDF 页面渲染到 canvas 上下文中
          let renderContext = {
            canvasContext: ctx,
            viewport: viewport
          };
          page.render(renderContext);
          if (this.pdfPages > num) {
            this.renderPage(num + 1);
          }
        });
      },
      onWebOprateOpen(){
        // this.style = document.body.getAttribute('style') || ''
        // document.body.setAttribute('style', this.style + 'overflow: hidden;')
        this.showWebOperate = true
        // this.loadFile('./學會報名操作流程.pdf')
      },
      onWebOprateClose(){
        this.showWebOperate = false
        document.body.setAttribute('style', this.style)
      },
      onDotChanged: function(index) {
        this.dotText = data.association.attachmentList[index].t
      },
      onRefresh: function() {
        this.loading = true
        this.$store.dispatch('getHomeInfos', {
            associationid: 4
        }).then(d=>{
            this.loading = false
            this.data = d
            try {
              this.dotImgs = this.data.association.attachmentList || []
              this.activitys = this.data.activity.list || []
              this.articles = this.data.article.list || []
              this.newsList = this.data.top_ass_news.list || []
              this.newsList2 = this.data.latest_ass_news.list || []

              this.videoUrl = (this.data.association && this.data.association.vedioconnection) || ''
              this.videoUrl2 = (this.data.association && this.data.association.vedioconnection2) || ''
              this.videoTitle = (this.data.association && this.data.association.vediotitle) || ''
              this.videoTitle2 = (this.data.association && this.data.association.vediotitle2) || ''
              if(! this.videoUrl.toLowerCase().startsWith('http')) {
                this.videoUrl = ''
              }
              if(! this.videoUrl2.toLowerCase().startsWith('http')) {
                this.videoUrl2 = ''
              }
            } catch (error) {
            }
        }).catch(error=>{
            this.loading = false
            this.$message.warning(error)
        })
      }
    }
  }
</script>

<style >
  .ant-modal {
    top: 50px;
  }

  .ant-modal-body {
    padding: 8px;
  }
  
  .web-oprate {
    margin-bottom: 10px;
    cursor: pointer;
    font-size: 28px;
    padding-left: 72px;
    line-height: 32px;
  }

  .web-oprate .ant-alert-message {
    color: #1890ff;
  }
  
  .home {
    width: 1000px;
    margin: 0 auto;
    position: relative;
  }

  .carousel-container {
    position: relative;
  }

  .carousel-container .hint {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 26px;
    line-height: 26px;
    background-color: rgba(0,0,0,.7);
    width: 100%;
    text-align: center;
    color: #fff;
    letter-spacing: 2px;
  }

  .ant-carousel >>> .slick-slide {
    text-align: center;
    background: #364d79;
    overflow: hidden;
  }

  .ant-carousel >>> .custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
  }

  .ant-carousel >>> .custom-slick-arrow:before {
    display: none;
  }
  
  .ant-carousel >>> .custom-slick-arrow:hover {
    opacity: 0.5;
  }

  .ant-carousel >>> .slick-slide h3 {
    color: #fff;
  }

  .carousel-item {
    display: block;
    width: 1000px;
    height: 400px;
    object-fit: cover;
  }

  .home .row {
    display: flex;
    flex-direction: row;
    min-height: 300px;
    margin-top: 20px;
  }

  .home .content-box {
    flex: 1;
    background-color: #fff;
    border: 1px solid #ebebeb;
  }


  .home .content-box .videos {
    position: relative;
    width: 100%;
    height: 300px;
    overflow: hidden;
    background-color: #fff;
  }

  .home .content-box .videos > .video {
    position: absolute;
    outline: none;
    left: 0;
    top: 0;
    width: 100%;
    height: 300px;
    object-fit: fill;
    background-color: #fff;
  }

  .home .content-box:nth-child(2) {
    margin-left: 20px;
  }
  
  .home .content-box > .head {
    display: flex;
    flex-direction: row;
    height: 40px;
    margin: 0 12px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
  }

  .home .content-box > .head > .more {
    font-size: 12px;
    color: #999;
    font-weight: 400;
  }

  .home .content-box > .head > .title {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }

  .home .content-box > .head > .title .anticon {
    margin-right: 8px;
  }

  .home .content-box > .list {
      display: grid;
      grid-template-columns: 50% 50%;
  }

  .home .content-box > .list > .item {
    margin: 10px;
  }

  .home .content-box > .list > .item img {
    width: 100%;
    height: 160px;
    object-fit: contain;
    padding: 10px;
    border: 1px solid #e8e8e8;
    box-sizing: border-box;
  }

  .home .content-box > .list > .item .title {
    margin-top: 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
    line-height: 20px;
    font-size: 16px;
    font-weight: 400;
    color: #232323;
  }

  .home .content-box > .datas {
    display: flex;
    flex-direction: column;
    margin-top: 8px;
  }

  .home .content-box > .datas > .data-item {
    height: 40px;
    line-height: 40px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    margin: 4px 12px;
    padding: 0 12px;
  }

  .home .content-box.news-list2 > .datas > .data-item {
    height: unset;
    line-height: unset;
    border: none;
    margin-bottom: 20px;
  }

  .home .content-box.news-list2 > .datas > .data-item > h3 {
    position: relative;
    padding-left: 24px;
    font-size: 18px;
    font-weight: bold;
    color: #232323;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .home .content-box.news-list2 > .datas > .data-item > h3::after {
    content: '';
    position: absolute;
    left: 0;
    top: 5px;
    width: 15px;
    height: 15px;
    background-image: url(../assets/imgs/book.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .home .content-box.news-list2 > .datas > .data-item > p {
    overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
  }

  @media only screen and (max-width: 1050px) {
    .home {
      width: 100%;
    }

    .home .row {
      margin-top: unset;
      display: flex;
      flex-direction: column;
    }

    .home .content-box > .list {
      display: grid;
      grid-template-columns: 100%;
      grid-template-rows: unset;
    }

    .carousel-container {
      position: relative;
      margin: 0px 12px;
    }

    .carousel-item {
      width: unset;
    }

    .home .content-box {
      margin: 12px;
      background-color: #f7f7f7;
    }

    .home .content-box:nth-child(2) {
      margin: 12px;
    }
    
    .home .content-box > .list > .item {
      margin: 12px;
      padding: 8px;
      background-color: #fff;
      box-shadow: 2px 2px 5px #e2e2e2;
      border-radius: 4px;
    }

    .home .content-box > .list > .item .title {
      margin-bottom: 20px;
    }

    .home .content-box > .head[data-v-8dc7cce2] {
      padding: 0 12px;
      margin: unset;
      background: #fff;
    }

    .home .content-box > .datas > .data-item {
      background-color: #fff;
      padding: 8px;
      line-height: unset;
    }

  }
</style>
